import * as Yup from 'yup';
import { isValidPhone } from '@rsos/base-utils/validators';
import { cleanPhoneNumber } from '@rsos/utils/phoneNumberUtils';

export const initialValues = {
  phoneNumber: '',
};

export const phoneNumberValidator = (
  phoneNumber: string | undefined,
): boolean => {
  if (!phoneNumber) {
    return false;
  }

  const sanitizedPhoneNumber = cleanPhoneNumber(phoneNumber);

  // If it's 10 digits, add country code and validate
  if (sanitizedPhoneNumber.length === 10) {
    return isValidPhone('1' + sanitizedPhoneNumber);
  }

  // If it's 11 digits, validate directly
  if (sanitizedPhoneNumber.length === 11) {
    return isValidPhone(sanitizedPhoneNumber);
  }

  return false;
};

export const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .test(
      'isValidPhone',
      'Please enter a valid 10-digit phone number',
      phoneNumberValidator,
    ),
});
